import React from "react";
import PropTypes from "prop-types";
import { Checkbox, Field, Hint, Input, Label } from "@zendeskgarden/react-forms";
import styled from "styled-components";

const Grid = styled('div')`
  display: grid;
  grid-template-columns: 6fr 2fr;
  grid-column-gap: 2rem;
`

const UnifyDateField = ({ value, onChange }) => {
  const handleOnChange = (data) => onChange({
    ...value,
    ...data,
  })
  return (
    <Grid>
      <Field>
        <Checkbox checked={value.checked} onChange={(e) => handleOnChange({ checked: e.target.checked})}>
          <Label>Unify start day</Label>
          <Hint>Scale to first day of epidemic on each country greater than "affected count". Pick long date range.</Hint>
        </Checkbox>
      </Field>
      <Field>
        <Label>Affected count</Label>
        <Input
          disabled={!value.checked}
          value={value.count}
          onChange={(e) => handleOnChange({count: e.target.value})}
          placeholder='set value'
        />
      </Field>
    </Grid>
  );
};

UnifyDateField.propTypes = {
  value: PropTypes.shape({
    checked: PropTypes.bool,
    count: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default UnifyDateField;
